module.exports = __webpack_public_path__ + "static/media/BannerLeft.ad41bb57.svg";